import { Technologie } from '../types/technologie';

export const TECHNOLOGIES: Technologie[] = [
    {
        id: '0196908f-4695-7b07-8408-cb7ec871278f',
        icon: 'fas fa-mobile-screen',
        title: 'Responsive Design',
        description:
            'Ob Smartphone, Tablet oder Desktop – Deine Website sieht überall stark aus. Du erreichst Deine Besucher jederzeit und überall.'
    },
    {
        id: '0196908f-817f-763a-87fb-3a8ce5d9e469',
        icon: 'fas fa-code',
        title: 'Moderne Frameworks',
        description:
            'Mit Technologien wie React, Redux und Motion bauen wir eine Website, die schnell lädt, flüssig läuft – und Zukunft hat.'
    },
    {
        id: '0196908f-9403-776f-96bf-153b5fc15f37',
        icon: 'fas fa-palette',
        title: 'Individuelles Design',
        description:
            'Dein Stil, Dein Eindruck, Deine Handschrift. Wir gestalten ein Design, das auffällt – und bleibt.'
    },
    {
        id: '0196908f-a7b4-7fea-95e1-f923d2c95fd1',
        icon: 'fas fa-globe',
        title: 'SEO-Optimierung',
        description:
            'Sei dort, wo Deine Kunden suchen. Mit unserer SEO-Optimierung wirst Du online besser gefunden – und häufiger gewählt.'
    }
];
